import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-cancel-charter-dialog',
  templateUrl: './chicken-test-dialog.component.html',
  styleUrls: ['./chicken-test-dialog.component.scss'],
})
export class ChickenTestDialogComponent implements OnInit {
  isConfirmation: boolean = false;
  testQuestion: string;
  testQuestionTwo: string;
  affirmativeText: string;
  negativeText: string;
  disclaimerText: string;
  titleText: string;
  enableRichText = false;

  constructor(
    private dialogRef: MatDialogRef<ChickenTestDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.testQuestion = this.data.testQuestion;
    this.testQuestionTwo = this.data.testQuestionTwo;
    this.negativeText = this.data.negativeText;
    this.affirmativeText = this.data.affirmativeText;
    this.enableRichText = this.data.enableRichText;
    if (this.data.disclaimerText) {
      this.disclaimerText = this.data.disclaimerText;
    }
    if (this.data.titleText) {
      this.titleText = this.data.titleText;
    } else {
      this.titleText = 'Are you sure?';
    }
    if (this.data.isConfirmation) {
      this.isConfirmation = true;
    }
  }

  ngOnInit() {}

  closeDialog(userResponse: boolean) {
    this.dialogRef.close(userResponse);
  }
}

// 🐔🐔🐔🐔🐔
